// Returns a random hex color string, e.g. #A1B2C3
export function getRandomColor() {
	return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
}
